<template>
    <div>
        <c-dialog ref="dialog" :title="dialogTitle" width="800" height="350">
            <div v-if="active == 1" class="tip-div">
                <div class="import-steps">
                    <h5>导入说明</h5>
                    <p>1.当上传的表格有多个Sheet时，仅解析第一个Sheet的数据；<span style="color:red">请保证导入Excel的第一行为表头信息</span>。</p>
                    <p>2.仅支持上传Excel文件(Excel2007及以上版本)，导入文件最大不超过5MB，数据不超过<span style="color: blue">50000</span>行。</p>
                    <c-button hollow size="m" @click="uploadHandle"><i class="tf tf-file-xls"></i>上传导入文件</c-button>
                    <div class="import-fruit flex-column flex-center" v-if="excel_file">
                        <h3 style="color: green">上传成功</h3>
                        <span style="color: #bd2c00">
                            {{this.excel_file}}
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="active == 2" class="tip-div">
                <div class="import-steps">
                    <div class="import-fruit flex-column flex-center">
                        <h2 style="color: green">数据导入处理中...</h2>
                        <p>
                            预计导入 {{this.importResult.total}}条数据；
                            已处理：<b style="color: green">{{this.importResult.processed}}条</b>；
                            进度：<b style="color: green">{{this.importResult.percentage}}%</b>
                        </p>
                    </div>
                </div>
            </div>

            <div v-if="active == 3" class="tip-div">
                <div class="import-steps">
                    <div class="import-fruit flex-column flex-center">
                        <h2 style="color: red">导入失败</h2>
                        <span style="color: #bd2c00">
                            {{this.errorMsg}}
                        </span>
                    </div>
                </div>
            </div>

            <div v-if="active == 4" class="tip-div">
                <div class="import-steps">
                    <div class="import-fruit flex-column flex-center">
                        <h2>导入结果</h2>
                        <p>
                            共导入
                            {{this.importResult.import_total_count}}条数据；
                            成功：<b style="color: green">{{this.importResult.import_success_count}}条</b>；
                            失败：<b style="color: red">{{this.importResult.import_fail_count}}条</b>；
                            忽略处理：<b style="color: blue">{{this.importResult.import_ignore_count}}条</b>
                            <a v-if="this.importResult.error_file_url" style="color:blue; margin-left: 20px;" @click="downloadErrorFile()">下载错误报告</a>
                        </p>
                    </div>
                </div>
            </div>
            <template #button>
                <c-button v-if="excel_file && active == 1"  size="m" @click="submit()">确定导入</c-button>
                <c-button v-if="active == 3||active == 4" size="m" @click="finish()">关闭</c-button>
            </template>
        </c-dialog>
    </div>
</template>

<script>
    import {mapState} from "vuex";

export default {
    name: 'platformUserInitImport',
    components: {

    },
    watch: {

    },
    data() {
        return {
            dialogTitle:'会员初始化导入',
            active:1,
            excel_file:'',              //上传文件路径
            importResult:{
                total:0,
                processed:0,
                percentage:0,
            },
            errorFlag:false,
            errorMsg:'',
            batchNo:'',
            interval:null,
            tryCount:0,
        }
    },

    computed: {
        // 获取dictName选项数据
        ...mapState(['userInfo', 'systemConfig']),
    },

    methods: {
        /************打开新增、编辑弹窗，数据初始化**************/
        open() {
            this.active = 1;//恢复初始值
            this.excel_file = '';
            this.errorFlag = false;
            this.importResult={
                total:0,
                        processed:0,
                        percentage:0,
            },
            this.$refs.dialog.open();
        },

        /*****************上传文件**********************/
        uploadHandle() {
            this.uploadFile({
                fileType:'xls,xlsx',
                success: data => {
                    this.excel_file = data.filePath||'';
                    if (!this.excel_file){
                        this.$message({
                            text: '请上传文件',  // 提示内容,
                            type: 'warn'
                        });
                        return;
                    }
                    var suffix = this.excel_file.substring(this.excel_file.lastIndexOf('.')+1).toLowerCase();
                    if (suffix!='xls' && suffix!='xlsx'){
                        this.$message({
                            text: '请上传Excel文件',  // 提示内容,
                            type: 'warn'
                        });
                        return;
                    }
                }
            });
        },

        //完成
        finish(){
            this.$refs.dialog.close();
        },

        /************下载错误文件************/
        submit(){
            this.request({
                url: '/platform_user/init/import',
                data: {
                    file_url: this.excel_file,
                },
                loading: {
                    message: '导入数据处理中...'
                },
                success: data => {
                    this.errorFlag = false;
                    this.batchNo = data.batch_no;
                    this.active = 2;
                    this.interval = setInterval(() => {
                        this.queryImportResult();
                    }, 3000);
                },
                fail: (code,obj,message) => {
                    if(obj.length>3){
                        this.errorMsg = message+"("+obj[0]+obj[1]+obj[2]+"等"+obj.length+"条数据)";
                    }else{
                        this.errorMsg = message+"("+obj+")";
                    }
                    this.active = 3;
                    this.errorFlag = true;
                }
            });
        },

        /************下载错误文件************/
        downloadErrorFile() {
            window.open(this.importResult.error_file_url);
        },
        /************定时查询导入结果************/
        queryImportResult(){
            this.tryCount++;
            this.request({
                url: '/platform_user/init/import_result',
                data: {
                    batch_no: this.batchNo,
                },
                loading: false,
                success: data => {
                    this.importResult = data;
                    this.active = 2;
                    if(data.import_result==='completed'){
                        this.active =4;
                        clearInterval(this.interval);
                    }
                    if(data.import_result==='failed'){
                        this.active =3;
                        clearInterval(this.interval);
                    }
                },
                fail: (code,obj,message) => {
                    if(this.tryCount>10){
                        clearInterval(this.interval);
                    }
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.tip-div {
    /* 四个值：上 | 右 | 下 | 左 */
    padding: 20px 20px 20px 20px;
}

.import-steps {
    padding: 10px 20px;
    background-color: #F8F8F8;

    h5 {
        line-height: 36px;
        font-size: 15px;
    }

    p {
        padding: 4px 0;
        line-height: 20px;
        color: #666;
    }
}

.import-explain {
    padding: 20px;

    >>> p {
        padding: 4px 0;
        line-height: 20px;
    }
}

.import-fruit {
    height: 150px;
    background-color: #F8F8F8;

    h1 {
        margin-bottom: 30px;
        font-size: 26px;
    }
}
</style>